import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Input, Label, UncontrolledTooltip, UncontrolledPopover, PopoverBody, Alert } from 'reactstrap';
import { getCookie } from '../jwt/_helpers/cookie';
import BootstrapTable from "react-bootstrap-table-next";
import axios from 'axios';
import LoaderInner from './LoaderInner';
import './preScan.css';

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const PreScan = ({
  id,
  name,
  pre_scan_done,
  pre_scan,
  release_pre_scan_declaration,
  status,
  release_admin_approval,
  action,
}) => {
    const tokenAPI = getCookie("token");
    const { setPreScanSuccess, setPreScanError, setPreScanDeclarationSignSuccess, setPreScanDeclarationSignError, forceUpdate, setForceUpdate } = action;

    const [modal, setModal] = useState(false);
    const [performScanModal, setPerformScanModal] = useState(false);
    const [scanInProgress, setScanInProgress] = useState(false);

    const [submissionInProgress, setSubmissionInProgress] = useState(false);
    const [declaration, setDeclaration] = useState(1);
    const [declarationSubmitted, setDeclarationSubmitted] = useState(false);

    const [iconColor, setIconColor] = useState('gray');
    const [messageColor, setMessageColor] = useState('warning');
    const [statusNoteText, setStatusNoteText] = useState('');

    const scanButtonEnabled = (pre_scan_done && declarationSubmitted) ? true : (release_admin_approval && (status === "admin_approval" || status === "ready"));

    const hasPreScanResults = pre_scan_done && pre_scan.alert && pre_scan.scanned_tracks;
    const scanCompleted = pre_scan && pre_scan.status === "completed";

    const showStatusNote = hasPreScanResults && declarationSubmitted;

    useEffect(() => {
        if(scanButtonEnabled && !pre_scan_done) {
            setIconColor('#ff0b4a');
            setMessageColor('danger');
        }
        else if (pre_scan_done && !declarationSubmitted) {
            setIconColor("var(--branding-theme-color, var(--theme-color, #2fbaad))");
        }
        else if (declarationSubmitted && release_pre_scan_declaration) {
            if (pre_scan && pre_scan.admin_declaration === 1) {
                setIconColor('#ff0b4a');
                setMessageColor('danger');
                setStatusNoteText('You have cancelled the distribution of the release, therefore it has been taken down.');
            } else {
                if (release_pre_scan_declaration.status === "approved") {
                    setIconColor('green');
                    setMessageColor('success');
                    setStatusNoteText(release_pre_scan_declaration.admin_message);
                }
                if (release_pre_scan_declaration.status === "rejected") {
                    setIconColor('#ff0b4a');
                    setMessageColor('danger');
                    setStatusNoteText(release_pre_scan_declaration.admin_message);
                }
                if (release_pre_scan_declaration.status === "pending") {
                    setIconColor('#f0c231');
                    setMessageColor('warning');
                    setStatusNoteText(release_pre_scan_declaration.admin_message);
                }
            }
        }
      }, [pre_scan, pre_scan_done, release_pre_scan_declaration, declarationSubmitted]);

    useEffect(() => {
        if(pre_scan && pre_scan.admin_declaration) {
            setDeclaration(pre_scan.admin_declaration);
            setDeclarationSubmitted(true);
        }
    }, [pre_scan]);

    const submitDeclaration = async () => {
        setSubmissionInProgress(true);
        try {
            const response = await axios.post(
                `${API_URL}release-acr-deep-scan/`,
                {
                    id: pre_scan.id,
                    admin_declaration: declaration,
                },
                {
                    headers: {
                        "Authorization": `Bearer ${tokenAPI}`,
                        "x-api-key": X_API_KEY,
                        "Content-Type": "application/json",
                    },
                }
            );
    
            if (response.status === 200) {
                setDeclarationSubmitted(true);
                setPreScanDeclarationSignSuccess(true);
                toggleModal();
                setTimeout(() => {
                setForceUpdate(forceUpdate + 1);
                }, (1000));
            } else {
                setPreScanDeclarationSignError(true);
                console.log("Error occurred while submitting admin pre scan declaration");
            }

        } catch (error) {
            setPreScanDeclarationSignError(true);
            console.log("Error occurred while submitting admin pre scan declaration, Error: ", error);
        } finally {
            setSubmissionInProgress(false);
        }
    };

    const performScan = async () => {
        try {
            setScanInProgress(true);
            let payload = {
                release_id: id,
            };
            const response = await axios.post(`${API_URL}releases/perform-pre-scan/`, payload, {
                headers: {
                    "Authorization": `Bearer ${tokenAPI}`,
                    "x-api-key": X_API_KEY,
                    "Content-Type": "application/json",
                },
            });
            if (response.status === 200) {
                setPreScanSuccess(true);
                setForceUpdate(forceUpdate + 1);
                setScanInProgress(false);
            } else {
                setPreScanError(true);
                setScanInProgress(false);
            }
            setTimeout(() => {
                togglePerformScanModal();
            }, 1000);
        } catch (error) {
            console.log("Error occurred while performing scan", error);
            setPreScanError(true);
            setScanInProgress(false);
            togglePerformScanModal();
        }
    }

    const toggleModal = () => setModal(!modal);
    const togglePerformScanModal = () => setPerformScanModal(!performScanModal);

    return (
        <div>
        {
            showStatusNote ? (
                <>
                <i 
                    className={"fas fa-bell fa-2x pre-scan-icon" + (showStatusNote ? " pre-scan-avl-icon" : "")}
                    id={`row-pre-scan-note-${id.toString()}`} 
                    aria-hidden="true" 
                    disabled={!showStatusNote}
                    style={{ color: iconColor }}
                ></i>
                <UncontrolledPopover trigger="legacy" id="qc-popover" placement="bottom" target={`row-pre-scan-note-${id.toString()}`} disabled={!showStatusNote}>
                <PopoverBody style={{ padding: "0px" }}>
                    <Alert 
                        color={messageColor}
                        style={{ fontSize: "14px", fontWeight: "bolder", margin: "0px", cursor: "pointer" }}
                        fade={true} 
                        isOpen={showStatusNote}
                    >
                        <b>{statusNoteText}</b>
                    </Alert>
                </PopoverBody>
                </UncontrolledPopover>
                </>
            ) : (
                pre_scan_done ? (
                    <>
                        <i 
                            className="fas fa-eye fa-2x pre-scan-icon pre-scan-avl-icon"
                            id={`row-scan-result-${id}`}
                        aria-hidden="true"
                        style={{ color: iconColor, cursor: "pointer" }}
                        onClick={scanCompleted ? toggleModal : undefined}
                    ></i>
                    {
                        !scanCompleted && (
                            <UncontrolledTooltip
                                placement="top"
                                trigger="hover"
                                target={`row-scan-result-${id}`}
                            >
                                Scan in progress, please wait for the scan to complete.
                            </UncontrolledTooltip>
                        )
                    }
                </>
            ) : (
            <>
                <i
                    className="fas fa-search fa-2x pre-scan-icon"
                    id={"row-pre-scan-" + id.toString()} 
                    aria-hidden="true" 
                    style={{ color: iconColor, cursor: "pointer" }}
                    disabled={!scanButtonEnabled}
                    onClick={scanButtonEnabled ? togglePerformScanModal : undefined}
                ></i>
                {
                    !scanButtonEnabled && (
                        <UncontrolledTooltip
                            placement="top"
                            trigger="hover"
                            target={`row-pre-scan-${id.toString()}`}
                            >
                                Release must be in Ready status to perform pre scan.
                        </UncontrolledTooltip>
                    )
                }
               </>
            )
        )}

        <Modal isOpen={modal} toggle={toggleModal} className="modal-lg">
            <ModalHeader toggle={toggleModal}>Pre-Scan Results</ModalHeader>
            <ModalBody>
                {hasPreScanResults ? (
                    <>
                        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                            <div className="mb-3">
                                Following results have been found after performing scan for this release, please check these in detail:
                            </div>
                            <h5>Flagged Tracks</h5>
                            <BootstrapTable
                                keyField="id"
                                data={pre_scan.scanned_tracks.flatMap((track) =>
                                track.alert ? [
                                    ...track.music_results.map((musicResult, index) => ({
                                        id: `${track.id}-music-${index}`,
                                        track_name: track.track_name,
                                        type: "Music",
                                        title: musicResult.result.title,
                                        artists: musicResult.result.artists.map(artist => artist.name).join(', '),
                                        album: musicResult.result.album.name,
                                        label: musicResult.result.label,
                                        release_date: musicResult.result.release_date,
                                        score: musicResult.score
                                    })),
                                    ...track.cover_results.map((coverSongResult, index) => ({
                                        id: `${track.id}-cover-${index}`,
                                        track_name: track.track_name,
                                        type: "Cover",
                                        title: coverSongResult.result.title,
                                        artists: coverSongResult.result.artists.map(artist => artist.name).join(', '),
                                        album: coverSongResult.result.album.name,
                                        label: coverSongResult.result.label,
                                        release_date: coverSongResult.result.release_date,
                                        score: coverSongResult.score
                                    }))
                                ] : []
                                )}
                                columns={[
                                {
                                    dataField: "track_name",
                                    text: "Track Name"
                                },
                                {
                                    dataField: "type",
                                    text: "Type"
                                },
                                {
                                    dataField: "title",
                                    text: "Title"
                                },
                                {
                                    dataField: "artists",
                                    text: "Artists"
                                },
                                {
                                    dataField: "album",
                                    text: "Album"
                                },
                                {
                                    dataField: "label",
                                    text: "Label"
                                },
                                {
                                    dataField: "release_date",
                                    text: "Release Date"
                                },
                                {
                                    dataField: "score",
                                    text: "Score (%)"
                                }
                                ]}
                                bordered={false}
                            />
                        </div>
                
                        <div className="mt-4 mb-4">
                            Please sign the declaration in order to proceed further
                            <br /><br />
                            <FormGroup check className="">
                                <Label check>
                                    <Input type="radio" id="cancel" name="declaration_cancel" value={1} onChange={() => {setDeclaration(1)}} checked={declaration===1} disabled={declarationSubmitted} />
                                    <span className="ml-2">I want to cancel this release.</span>
                                </Label>
                            </FormGroup>
                            <FormGroup check className="mt-3">
                                <Label check>
                                    <Input type="radio" id="approve" name="declaration_approve" value={2} onChange={() => {setDeclaration(2)}} checked={declaration===2} disabled={declarationSubmitted} />
                                    <span className="ml-2">
                                        I want to approve this release because the results shown are 100% identical to my own release / transferring from the previous distributor.<br/>
                                        I hereby solemnly declare, under penalty of perjury, that all content I provide is owned by my company or me, or that I hold full and valid rights and licences necessary for its use, distribution, and submission.<br/>
                                        I acknowledge and accept that I am fully responsible for any legal consequences arising from the submission of such content, including but not limited to legal proceedings, claims, costs, and fees.<br/>
                                        I further understand and agree that my personal data, including KYC information and any other relevant data, may be shared with authorised partners, digital service providers (DSPs), third parties involved in the processing of such content, as well as courts, regulatory authorities, and law enforcement agencies in the event of any claim, dispute, or legal requirement.<br/>
                                        I understand and agree that Move Music reserves the right to immediately terminate my agreement, without any compensation or further obligation, if it is proven that I have misused this form or if any part of my declaration is false, misleading, or misrepresented.<br/>
                                    </span>
                                </Label>
                            </FormGroup>
                        </div>
                    </>
                ): (
                    <div>
                        No flagged tracks detected in the pre-scan, you can proceed with next steps!
                    </div>
                )}
            </ModalBody>
            <ModalFooter>
                {
                    hasPreScanResults && (
                    <Button color="success" onClick={submitDeclaration} disabled={submissionInProgress ||  declarationSubmitted}>Submit</Button>
                )}
                <Button color="secondary" onClick={toggleModal}>Close</Button>
            </ModalFooter>
        </Modal>

        <Modal isOpen={performScanModal} toggle={togglePerformScanModal}>
            <ModalHeader toggle={togglePerformScanModal}>Perform Pre-Scan</ModalHeader>
            <ModalBody>
                <div className="mb-3">
                    Please confirm that you want to perform pre-scan for this release.
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={togglePerformScanModal} disabled={scanInProgress}>Cancel</Button>
                <Button color="success" onClick={performScan} disabled={scanInProgress}>Perform Scan</Button>
            </ModalFooter>
        </Modal>
        <LoaderInner show={scanInProgress} />
        </div>
    );
};

export default PreScan;